import type { MeasurementUnit } from '../models';
import type { ItemType } from './item';
import type { SaleItemModifier } from './sale';

export interface RemoteCartItem {
    id: string;
    itemId: string;
    variantId: string;
    variantName: string;
    itemName: string;
    itemType: ItemType;
    measurementUnit?: MeasurementUnit;
    quantity: number;
    comment?: string;
    price: number;
    pricingGroupId?: string;
    uomId?: string;
    baseUomId?: string;
    conversionRatio?: number;
    selectedModifiers?: SaleItemModifier[];
}

export const REMOTE_CART_STATUS = {
    ACTIVE: 'ACTIVE',
    SAVED: 'SAVED',
    VOID: 'VOID',
    COMPLETED: 'COMPLETED',
} as const;

export type RemoteCartStatus =
    (typeof REMOTE_CART_STATUS)[keyof typeof REMOTE_CART_STATUS];

export const REMOTE_CART_SYNC_STATUS = {
    PENDING: 'PENDING',
    FAILED: 'FAILED',
    SYNCED: 'SYNCED',
} as const;

export type RemoteCartSyncStatus =
    (typeof REMOTE_CART_SYNC_STATUS)[keyof typeof REMOTE_CART_SYNC_STATUS];

export interface MappedRemoteCartResponse {
    id: string;
    name: string;
    comment: string;
    registerId: string;
    items: RemoteCartItem[];
    createdAt: string;
    updatedAt: string;
    createdById: string;
    updatedById: string;
    updatedByName: string;
    createdByName: string;
    totalAmount: number;
    version: string;
    deleted: boolean;
    orderNote: string;
    customerId: string;
    orderNumber: string;
    status: RemoteCartStatus;
}
